<script setup>

import channelsightWidget from './js/channelsight-widget.js';
import dataModel from './js/model.js';
import logoBar from './components/logoBar.vue';
import hero from './components/hero.vue';
import heroCopy from './components/slots/hero/heroCopy.vue';
import widget from './components/widget.vue';
import intro from './components/intro.vue';
import introCopy from './components/slots/intro/introCopy.vue';
import carousel from './components/carousel.vue';
import carouselFull from './components/carouselFull.vue';
import csModal from './components/csModal.vue';
import terms from './components/terms.vue';

//invoke the channelsight widget
channelsightWidget();

//grab URL parameter to determine experience
let params = new URLSearchParams(document.location.search);
let brandContextParam = params.get("brandContext");

//parse URL parameter ready to pass to component
var brandContext = (!brandContextParam == '' && brandContextParam <= Object.keys(dataModel).length) ? brandContext=brandContextParam : console.log('Generating experience ' + brandContextParam);

</script>

<template>
  <logoBar :brandExperience="brandContext" />
  <hero :brandExperience="brandContext">
    <heroCopy :brandExperience="brandContext" />
  </hero>
  <widget :brandExperience="brandContext" />
  <intro :brandExperience="brandContext">
    <introCopy :brandExperience="brandContext" />
  </intro>
  <carouselFull :iteration="'2'" :brandExperience="brandContext"/>
  <carousel :iteration="'1'" :brandExperience="brandContext"/>
  <csModal :brandExperience="brandContext" />
  <terms :brandExperience="brandContext" />
</template>

<style>
body, html {
  height: 100%;
  margin: 0;
}
#app {
  text-align: center;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}
</style>
